import { Field, Form, HousingAlert, Icon, Sender } from "@garantidos/components"

import If from "@mobi/components/If"
import Text from "@mobi/ds/components/Text"
import useMediaQuery from "@mobi/hooks/useMediaQuery"

import Financed from "./components/Financed"
import Unqualified from "./components/Unqualified"

import useQualification from "./hooks"

import "./style.scss"

const Qualification = () => {
  const isMobile = useMediaQuery("mobile")

  const {
    handlePrevStep,
    onSubmitCallback,
    fields,
    form,
    errorMessage,
    setErrorMessage,
    isUnqualified,
    isPropertyOwner,
    isSettled,
    unqualifiedMessage,
    settledRef,
    propertyOwnerRef,
    PropertyRegistrationUpdatedRef,
    alertRef,
    isValidForm,
    handleUnqualifiedTracking,
    isLoading,
    isFinanced
  } = useQualification()

  const { propertyStatus, propertyOwner, propertyRegistrationUpdated } = fields

  return (
    <div className="qualification">
      <div className="qualification__formWrapper">
        <HousingAlert
          message={errorMessage}
          setMessage={setErrorMessage}
          type="error"
        />
        <h1 className="qualification__title">
          muito bem! agora nos conte sobre o imóvel que usará como garantia
        </h1>
        <Text p className="qualification__text">
          para enviar sua proposta, precisamos antes que nos responda algumas
          perguntas
        </Text>
        <Form
          onSubmit={onSubmitCallback}
          form={form}
          data-testid="qualification_form"
        >
          <div className="qualification__question" ref={settledRef}>
            <div role="group" aria-labelledby="p_situacao_imovel" className="qualification__radiobutton">
            <Text as="p" className="qualification__label" id="p_situacao_imovel">
              qual a situação do imóvel?
            </Text>
            <Field
              field={propertyStatus}
              form={form}
              required
              isDisabled={isLoading}
            />
            </div>
            <div className="qualification__card">
              <Icon
                icon="home"
                className="qualification__icon"
                alt="Ícone de residência"
                aria-hidden
              />
              <Text as="p" className="qualification__cardText">
                <b>Imóveis aceitos:</b> residenciais e comerciais. <br />
                <b>Imóveis não aceitos:</b> lotes, terrenos, galpão ou édicula,
                imóvel de madeira (todo ou estrutura) ou pré-fabricado
              </Text>
            </div>
            <If
              condition={isFinanced}
              renderIf={<Financed isMobile={isMobile} />}
            />
          </div>

          <If
            condition={isSettled}
            renderIf={
              <>
                <div className="qualification__question" ref={propertyOwnerRef}>
                  <div role="group" aria-labelledby="p_imovel_seu_nome" className="qualification__radiobutton">
                  <Text as="p" className="qualification__label" id="p_imovel_seu_nome">
                    o imóvel está em seu nome?
                  </Text>
                  <Field
                    field={propertyOwner}
                    form={form}
                    required
                    isDisabled={isLoading}
                  />
                  </div>
                  <div className="qualification__card">
                    <Icon
                      icon="carteirada"
                      className="qualification__icon"
                      alt="Ícone de duas mãos se comprimentando"
                      aria-hidden
                    />
                    <Text as="p" className="qualification__cardText">
                      O imóvel pode ter <b>até duas</b> pessoas proprietárias
                    </Text>
                  </div>
                </div>
                <If
                  condition={isPropertyOwner}
                  renderIf={
                    <div
                      className="qualification__question"
                      ref={PropertyRegistrationUpdatedRef}
                    >
                      <div role="group" aria-labelledby="p_imovel_cartorio" className="qualification__radiobutton">
                      <Text as="p" className="qualification__label" id="p_imovel_cartorio">
                        os dados do seu imóvel estão atualizados junto ao
                        cartório de imóveis?
                      </Text>
                      <Field
                        field={propertyRegistrationUpdated}
                        form={form}
                        required
                        isDisabled={isLoading}
                      />
                      </div>
                      <div className="qualification__card">
                        <Icon
                          icon="documento"
                          className="qualification__icon"
                          alt="Ícone de um contrato"
                          aria-hidden
                        />
                        <Text as="p" className="qualification__cardText">
                          A matrícula do imóvel, emitida pelo Cartório de
                          Registro de Imóveis, deve estar atualizada com todas
                          as informações do imóvel e proprietários
                        </Text>
                      </div>
                    </div>
                  }
                />
              </>
            }
          />

          <Unqualified
            alertRef={alertRef}
            unqualified={isUnqualified}
            message={unqualifiedMessage}
            handleUnqualifiedTracking={handleUnqualifiedTracking}
          />

          <Sender
            onPrev={handlePrevStep}
            isNextDisabled={!(isValidForm || (isFinanced && isMobile))}
            nextLabel={
              isFinanced && isMobile ? "continuar no aplicativo" : "próximo"
            }
            data_testid="submit"
            isLoading={isLoading}
          />
        </Form>
      </div>
    </div>
  )
}

export default Qualification
